<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div id="myDiv" ref="myDiv" class="container-fluid mt--6x">
      <div class="card">
        <div class="card-header border-0">
          <base-button @click="get_pdf()" color="danger">
            <i class="far fa-file-pdf"></i> Descargar
          </base-button>
          <div class="row mt-3">
            <div class="col-sm-12 text-center pb-0 mb-0 " style="max-height:600px;" v-if="meal">
              <img :src="meal.preparation_photo_url" alt style="width:60%;height:90%" />
            </div>
            <div class="col-6">
              <h1>{{ meal.name }}</h1>
            </div>
            <div class="col-6 text-right">
              <i class="fas fa-clock"></i>
              Tiempo de elaboración: {{meal.cook_minutes}} minutos
            </div>
          </div>
          <div class="row m-3" v-if="meal">
            <h3>Ingredientes: </h3>
            <table width="100%" border="1">
                <thead>
                    <th>Subgrupo</th>
                    <th>Nombre</th>
                    <th>Peso</th>
                    <th>Corte</th>
                </thead>
                <tbody>
                    <tr v-for="subgroup in meal.subgroups" :key="subgroup.id">
                        <td class="text-center">
                            {{subgroup.name}}
                        </td>
                        <td>
                            <div class="col-12 border" v-for="ingredient in subgroup.ingredients" :key="ingredient.id">
                                {{ingredient.NOMALIM}}
                            </div>
                        </td>
                        <td>
                            <div class="col-12 border" v-for="ingredient in subgroup.ingredients" :key="ingredient.id+'portion'">
                                {{ingredient.porcion}} gr
                            </div>
                        </td>
                        <td>
                            <div class="col-12 border" v-for="ingredient in subgroup.ingredients" :key="ingredient.id+'portion'">
                                {{ingredient.cut_name}}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>
          <div class="row m-3">
            <h3>Preparación: </h3>
            <table width="100%" border="1">
                <thead>
                    <th>Subgrupo</th>
                    <th>Procedimiento</th>
                    <th>Variación</th>
                    <th>Peso</th>
                </thead>
                <tbody>
                    <tr v-for="subgroup in meal.subgroups" :key="subgroup.id">
                        <td class="text-center">
                            {{subgroup.name}}
                        </td>
                        <td>
                            <p>{{subgroup.preparation}}</p>
                        </td>
                        <td class="text-center">
                            {{subgroup.reduction}}%
                        </td>
                        <td class="text-center">
                            {{ parseInt((subgroup.porcion * subgroup.reduction) / 100) }}
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>
          <div class="row mt-3">
            <div class="col-12" v-if="meal">
                <h3>Sabor: </h3>
                <p>{{meal.taste}}</p>
            </div>
            <div class="col-12" v-if="meal">
                <h3>Presentación: </h3>
                <p>{{meal.presentation}}</p>
            </div>
            <div class="col-12" v-if="meal">
                <h3>Recomendaciones: </h3>
                <p>{{meal.reco}}</p>
            </div>
            <div class="col-12" v-if="meal">
                <h3>Reemplazo: </h3>
                <p>{{meal.replaceDetail}}</p>
            </div>
            <div class="col-12" v-if="meal">
              <h3>Pesos finales: </h3>
              <table class="weight">
                <thead>
                  <th>Calorias</th>
                  <th>Peso</th>
                </thead>
                <tbody>
                <tr v-for="weights in meal.weights" :key="weights.calories">
                  <td class="text-center">
                    {{ weights.calories }}
                  </td>
                  <td class="text-center">
                    {{ weights.weight }}gr
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="print"></div>
  </div>
</template>
<script>
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      meal: {},
      currentPage: 1,
      selectedRows: [],
      date: "2019-05-17",
    };
  },
  mounted() {
    this.getRecipe();
  },
  watch: {},
  methods: {
    get_pdf() {
      const modal = document.getElementById("myDiv");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }
      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },
    getRecipe() {
      axios.get("meals/" + this.$route.params.id).then((resp) => {
        this.meal = resp.data;
      });
    },
  },
};
</script>
<style lang="scss">
.weight {
  width: 30%;
  border: 1px solid black;
  td, th, tr {
    border: 1px solid black;
  }
}
</style>
<style>
.noMargin {
  margin-bottom: 0rem;
}
.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p{
    white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
